const HeadingButton = ({
  Heading = 'KYC History',
  pendingCount = 0,
  approvedCount = 0,
  declinedCount = 0,
  moreInfoCount = 0,
  handleButtonClick,
  activeButton,
  showMoreInfo = true
}) => {
  const getButtonClass = content => {
    return activeButton === content
      ? 'px-4 py-2 text-[#000000] font-[500] bg-[#00811D1A] rounded-md whitespace-nowrap'
      : 'px-4 py-2 text-[#0F172ACC] font-[400] bg-white border border-gray-300 rounded-md whitespace-nowrap'
  }

  return (
    <div className='flex flex-col md:items-center justify-between mb-6 md:flex-row md:space-y-0 space-y-4'>
      <h1 className='tableHeading'>{Heading}</h1>
      <div className='flex items-center space-x-2 overflow-hidden overflow-x-auto'>
        <button
          className={getButtonClass('pending')}
          onClick={() => handleButtonClick('pending')}
        >
          Pending: {pendingCount}
        </button>
        <button
          className={getButtonClass('approved')}
          onClick={() => handleButtonClick('approved')}
        >
          Approved: {approvedCount}
        </button>
        <button
          className={getButtonClass('rejected')}
          onClick={() => handleButtonClick('rejected')}
        >
          Declined: {declinedCount}
        </button>
        {showMoreInfo && (
          <button
            className={getButtonClass('more-info')}
            onClick={() => handleButtonClick('more-info')}
          >
            More Info Required: {moreInfoCount}
          </button>
        )}
      </div>
    </div>
  )
}

export default HeadingButton
